import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import Hero from "./components/Hero";
import ProblemSection from "./components/ProblemSection";
import SolutionSection from "./components/SolutionSection";
import FeaturesSection from "./components/FeaturesSection";
import IndustriesSection from "./components/IndustriesSection";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <ProblemSection />
        <SolutionSection />
        <FeaturesSection />
        <IndustriesSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}